import Link from '@atlaskit/link/link';

import StoryObject from '@atlaskit/object/story';

import { Inline } from '@atlaskit/primitives/compiled/inline';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import { PlacementFrontend } from '@post-office/browser--marketplace/sample-placement';

import type {
	AnyFrontendStage,
	FrontendPlacementMessage,
} from '@post-office/message-maker-browser/types';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import { type MessageTemplateContext } from '../../../index';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ message, link }: MessageTemplateContext) => (
			<Inline alignBlock="center" space="space.200">
				<StoryObject label="" />
				<Stack>
					<span>{message}</span>
					{link && (
						<Link href={link.href} target="blank">
							{link.text}
						</Link>
					)}
				</Stack>
			</Inline>
		),
	},
});
